<template>
  <div>
    <page-header>
      <template #breadcrumbs>
        <router-link to="/settings">Настройки</router-link> &raquo;
        <template v-if="item">Редактирование новости</template>
        <template v-else>Создание новости</template>
      </template>
      <h2>Карточка новости</h2>
    </page-header>

    <ul class="nav nav-tabs nav-justified p-3 d-flex align-items-center">
      <li class="nav-item">
        <a class="nav-link" @click.prevent="setActive('tab1')" :class="{ active: isActive('tab1') }" href="#tab1">
          Основная информация
          <i class="fas fa-info-circle text-danger ml-2" v-if="mainInfoInvalid"></i>          
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click.prevent="setActive('tab2')" :class="{ active: isActive('tab2') }" href="#tab2">
          Текст
          <i class="fas fa-info-circle text-danger ml-2" v-if="textInvalid"></i>          
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click.prevent="setActive('tab3')" :class="{ active: isActive('tab3') }" href="#tab3">Фото</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click.prevent="setActive('tab4')" :class="{ active: isActive('tab4') }" href="#tab4">Файлы</a>
      </li>
    </ul>
    <div class="card">
      <div>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade" :class="{ 'active show': isActive('tab1') }" id="tab1"
            v-disable-all="isReadonly">
            <div class="row pb-2">
              <div class="form-group col col-md-6">
                <component-input
                    label="Номер публикации"
                    v-model="item.id"
                    :disabled="true"
                    />
              </div>
              <div class="form-group col col-md-6 required">
                <component-input
                    placeholder="Введите статус"
                    v-model="item.newsStatus"
                    type="select2"
                    :select2Options="newsStatuses" 
                    :select2Settings="select2Settings"
                    label="Статус новости"
                    scopeName="mainInfo"
                    required />
              </div>
            </div>
            <div class="row pb-2">
              <div class="form-group col col-md-6 required">
                <div class="required pb-2">
                  <component-input
                      label="Заголовок новости"
                      placeholder="Введите заголовок"
                      v-model="item.name"
                      scopeName="mainInfo"
                      required/>
                </div>
                <div class="required">
                  <component-input
                    v-model="item.previewText"
                    type="textarea"
                    label="Анонс"
                    required
                    scopeName="mainInfo"
                    placeholder="Введите текст для анонса"/>
                </div>
              </div>
              <div class="form-group col col-md-6">
                <label class="control-label">Изображение для анонса</label>
                <picture-upload
                  :clearable="true"
                  :initialPhoto="item.previewPicture"
                  v-on:pictureSelected="pictureSelected"
                  :readOnly="isReadonly"
                />
              </div>
            </div>
            <div class="row pb-2">
              <div class="form-group col">
                <component-input
                  v-model="item.links"
                  type="textarea"
                  label="Ссылки на внешние источники данных"
                  placeholder="Введите ссылки на внешние источники данных"/>  
              </div>
            </div>
            <div class="row pb-2">
              <div class="form-group col col-md-6">
                <component-input
                    label="Дата публикации"
                    :modelValue="item.activeFrom ? $momentFormat(item.activeFrom, 'DD.MM.YYYY HH:mm') : ''"
                    :disabled="true"
                    />
              </div>
              <div class="form-group col col-md-6">
                <component-input
                    label="Дата снятия с публикации"
                    :modelValue="item.activeFrom ? $momentFormat(item.activeTo, 'DD.MM.YYYY HH:mm') : ''"
                    :disabled="true"
                    />
              </div>
            </div>
            <div class="row pb-2">
              <div class="form-group col col-md">
                  <component-input
                      placeholder="Все"
                      v-model="item.roleIds"
                      type="select2"
                      :select2Options="roles" 
                      :select2Settings="{multiple:true,language:'ru'}"
                      label="Роли, которым доступна новость"
                       />
              </div>
            </div>
          </div>
          <div class="tab-pane fade" :class="{ 'active show': isActive('tab2') }" id="tab2"
            v-disable-all="isReadonly">
            <div class="form-group required">
              <label class="control-label text-required">Текст новости</label>
              <editor
                  api-key="no-api-key"
                  v-model="item.body"
                  :init="tinyOptions"
                  :value="item.body"
                  :disabled="isReadonly"
                  required
                  scopeName="text"
                  output-format="html"
              />
              <div class="invalid-msg" v-if="textInvalid">
                Поле обязательно для заполнения
              </div>
            </div>
          </div>
          <div class="tab-pane fade" :class="{ 'active show': isActive('tab3') }" id="tab3"
               v-disable-all="isReadonly">
               <file-multi-upload
                  :entity="item"
                  prop-name="photos"
                  :user-data="fileType.photo"
                  accept="image/*"
                  :key="photos"
                  :show-preview="true"
                  @uploaded="fileUploaded"
                  @deleteFile="removeFile"
                  :readonly="isReadonly"
              />
          </div>
          <div class="tab-pane fade" :class="{ 'active show': isActive('tab4') }" id="tab3"
                v-disable-all="isReadonly">
            <file-multi-upload
              :entity="item"
              prop-name="otherFiles"
              :user-data="fileType.other"
              :key="other"
              @uploaded="fileUploaded"
              @deleteFile="removeFile"
              :readonly="isReadonly"
            />
          </div>
        </div>
        <div class="card-footer mt-5">
          <div class="d-flex align-items-center float-right">
            <button-component class="btn btn-primary mx-2" v-on:click="save" v-if="!isReadonly">Сохранить
            </button-component>
            <button-component kind="secondary" type="button" class="btn btn-default" v-on:click="close">Закрыть
            </button-component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from "@/common/components/page/PageHeader";
import ButtonComponent from "@/common/ui/ButtonComponent";
import API from '../api/news';
import RoleAPI from "@/modules/admin/api/roles";
import ComponentInput from "@/common/components/ComponentInput";
import Constants from "@/common/constants";
//import {required} from "@vuelidate/validators";
import {useVuelidate} from '@vuelidate/core'
import disableAll from "@/common/directives/disable-all";
import PictureUpload from "@/common/components/PictureUpload";
import Editor from '@tinymce/tinymce-vue';
import FileMultiUpload from "@/common/components/FileMultiUpload";

export default {
  name: "NewsCard",
  components: {
    PageHeader, ButtonComponent, ComponentInput, PictureUpload, Editor, FileMultiUpload
  },
  directives: {
    'disable-all': disableAll
  },
  created() {
    this.loadDictionaries();
    this.loadPage();
  },
  data() {
    return {
      id: this.$route.params.id,
      isReadonly: this.$route.params.action === "view",
      item: {
        files: []
      },
      activeItem: 'tab1',
      newsStatuses: [],
      roles: [],
      select2Settings: Constants.select2Settings,
      select2SettingsMultiple: Constants.select2SettingsMultiple,
      tinyOptions:{
        height: 500,
        menubar: false,
        plugins: [
          'advlist autolink lists link charmap preview anchor',
          'searchreplace visualblocks code',
          'media table paste code wordcount'
        ],
        toolbar:
            'undo redo | formatselect | bold italic backcolor forecolor | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist outdent indent | removeformat | help',
        language: 'ru'
      },
      fileType: {
        photo: 1,
        other: 2
      },
      photos: 1,
      other: 2,
      mainInfoInvalid: false,
      textInvalid: false
    };
  },
  methods: {
    isActive(menuItem) {
      return this.activeItem === menuItem
    },
    setActive(menuItem) {
      this.activeItem = menuItem
    },
    loadPage() {
      if (this.id >0)
        API.find(this.id).then((response) => {
          this.item = response.data;        
        });
    },
    loadDictionaries() {
      API.getNewsStatuses().then(response => {
        this.newsStatuses = response.data;
      });
      RoleAPI.search({ active: true }).then(response => {
        this.roles = response.data.items.map(x => { return { id: x.id, text: x.name } } );
      });
    },
    save() {
      this.mainInfoInvalid = false;
      this.textInvalid = false;     
      this.v$.$touch();
      if (this.v$.$invalid || !this.item.body) {
        this.v$.$errors.forEach(e => {
          if (
            e.$response.extraParams &&
            e.$response.extraParams.scope === "mainInfo"
          ) {
            this.mainInfoInvalid = true;
          }          
        });
        if (!this.item.body) {
          this.textInvalid = true;
        }
        Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
        return;
      }      

      this.item.newsStatus = Number(this.item.newsStatus);      

      API.save(this.item).then((response) => {
        const msg = 'Данные успешно сохранены.'
        Constants.alert.fire('Сохранение', response.data.success ? msg : response.data.message, response.data.success ? 'success' : 'error');
        if (response.data.success) {
          this.$router.push({path: '/settings'});
        }
      }).catch(() => {
        Constants.alert.fire('Сохранение', "Не удалось сохранить данные. Проверьте правильность заполнения полей", 'error');
      });
    },
    close() {
      this.$router.push({path: '/settings'});
    },
    pictureSelected(data) {
      this.item.previewPicture = data;
    },
    fileUploaded(e) {
      e.data.newsFileType = e.userData;
      this.item.files.push(e.data);
    },
    removeFile(e) {
      const file = this.item.files.find(x => x.id === e.id);
      const index = this.item.files.indexOf(file);
      if (index > -1) {
        this.item.files.splice(index, 1);
      }
    },
  },
  computed: {
    fileList() {
      return this.item?.files?.slice();
    },
  },
  watch: {
    fileList: {
      handler: function() {
        this.item.photos = this.item.files?.filter(f => f.newsFileType === this.fileType.photo);
        this.item.otherFiles = this.item.files?.filter(f => f.newsFileType === this.fileType.other);
        console.log(this.item);
        const now = (new Date()).getTime();
        this.photos += now;
        this.other += now;
      }
    },
  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
    return {
      item: {}
    }
  }
}
</script>
<style lang="scss">
  .tox-statusbar__branding,
  .tox-notification.tox-notification--in.tox-notification--warning{
    display: none;
  }
</style>
<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.nav-tabs {
  justify-content: center;
  border: none;

  .nav-item {
    max-width: 240px;
    width: 100%;
    margin-top: 12px;
    min-width: 250px;
    margin-left: 8px;
    margin-right: 8px;

    .nav-link {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 14.5px 20px;
      font-family: "Source Sans Pro", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 120%;
      color: $gray-dark;
      border: 1px solid $gray-light1;
      box-sizing: border-box;
      border-radius: 6px;

      &.active {
        color: $blue-light;
        border: 1px solid $blue-light;
      }
    }
  }
}

.card {
  padding: 24px;
  margin: 16px 24px 0 24px;
  border-radius: 12px;
  border: none;
  box-shadow: none;
  background-color: #fff;
}

.text-required:after {
  content: "*";
  color: red;
}
</style>